<template>
  <div>
    <gj-market-select
        initValue
        adMarket
        :clearable="false"
        v-model="filter.marketId"
        placeholder="全部店铺"
        @input="marketChange($event)"
        width="130px"
    ></gj-market-select>
    <gj-select
        v-model="filter.state"
        :options="option.adState"
        placeholder="活跃状态"
        @input="$emit('state-input', $event)"
        width="120px"
        style="margin-left: 8px;"
    ></gj-select>

    <gj-virtual-select
        v-if="campaign"
        v-model="filter.campaignId"
        :list="option.campaignOption"
        placeholder="所有广告活动"
        :loading="option.campaignLoading"
        @input="campaignChange($event)"
        width="160px"
        style="margin-left: 8px;"   
        clearable 
        :filterable="false"
      >
    </gj-virtual-select>

    <!-- <gj-select
        v-if="campaign"
        v-model="filter.campaignId"
        :options="option.campaignOption"
        placeholder="所有广告活动"
        :loading="option.campaignLoading"
        @input="campaignChange($event)"
        width="120px"
        style="margin-left: 8px;"
    ></gj-select> -->
    <gj-select
        v-if="group"
        v-model="filter.groupId"
        :options="option.groupOption"
        :loading="option.groupLoading"
        placeholder="所有广告组"
        width="120px"
        style="margin-left: 8px;"
        @input="$emit('group-input', $event)"
    ></gj-select>
  </div>
</template>

<script>
  import {getSpAdCampaignStrategyList, getSpAdGroupStrategyList} from "../../../../../api/ad";
  import {isMeaningless} from "../../../../../utils/common";

  export default {
    name: "app-sp-ad-market-campaign-group-select",
    props: {
      campaign: {
        type: Boolean,
        default: true,
      },
      group: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        filter: {
          marketId: null,
          campaignId: null,
          state: null,
          groupId: null,
        },
        option: {
          campaignOption: [],
          adState: [
            {id: 0, text: '活跃'},
            {id: 1, text: '不活跃'}
          ],
          campaignLoading: false,
          groupOption: [],
          groupLoading: false,
        },
      }
    },
    methods: {
      marketChange(marketId) {
        this.$emit('market-input', marketId);
        this.option.campaignLoading = true;
        this.option.campaignOption = [];
        this.filter.campaignId = null;
        this.filter.state = null;
        this.option.groupOption = [];
        this.filter.groupId = null;
        getSpAdCampaignStrategyList({
          marketId,
        })
          .then((data) => {
            if (data) {
              this.option.campaignOption = data.map(e => ({
                id: e.campaignId,
                text: e.campaignName
              }));
            }
          })
          .then(() => this.option.campaignLoading = false);
      },
      campaignChange(campaignId) {
        this.$emit('campaign-input', campaignId);
        if (isMeaningless(this.filter.marketId)) {
          return;
        }
        this.option.groupOption = [];
        this.filter.groupId = null;
        this.option.groupLoading = true;
        getSpAdGroupStrategyList({
          marketId: this.filter.marketId,
          campaignId
        })
          .then((data) => {
            if (data) {
              this.option.groupOption = data.map(e => ({
                id: e.groupId,
                text: e.groupName,
                bid: e.defaultBid
              }))
            }
          })
          .then(() => this.option.groupLoading = false);
      },
    }
  }
</script>

<style scoped>

</style>
